<template>
    <div class="learn">
        <div class="setting">
            <div class="setting___index">
                <template v-for="(item, key) in detailConfig">
                    <div :key="key">
                        <el-row>
                            <el-col :span="16">
                                <div class="setting___header">{{ item.title }}</div>
                                <div class="setting___content">{{ item.content }}</div>
                            </el-col>
                            <el-col :span="8" class="t-right">
                                <el-button size="small" @click="SettingProduct(item)"
                                    >开始设置</el-button
                                >
                            </el-col>
                        </el-row>
                        <template v-if="key < detailConfig.length - 1">
                            <el-divider></el-divider>
                        </template>
                    </div>
                </template>
            </div>
        </div>

        <v-ManageForm
            :detailParam="componentParam.manageForm"
            v-if="componentParam.manageForm.visible"
        />
    </div>
</template>

<script>
import { UserData } from '@/plugin/User'
import { ProductData } from '@/plugin/Product'
import ManageForm from '@/components/manage/Form'
export default {
    components: {
        'v-ManageForm': ManageForm
    },
    inject: ['reload'],
    mixins: [UserData, ProductData],
    data() {
        return {
            detailConfig: [
                {
                    key: 'question',
                    title: '权限设置',
                    content: '设置成员权限'
                },
                {
                    key: 'exam',
                    title: '商品扩展字段',
                    content: '设置谁可以创建考试任务'
                }
            ],
            componentParam: {
                manageForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        SettingProduct(row) {
            this.componentParam.manageForm = {
                visible: true,
                row: {
                    table_name: row.key
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/setting.less';
</style>
